import { isUserConnected } from "../extension.js";

//declare posthog as a global variable
export declare const posthog: {
  setPersonProperties: (props: Record<string, unknown>) => void;
  capture: (event: string, props?: Record<string, unknown>) => void;
};

export const identifyPosthogUser = async () => {
  const userConnected = isUserConnected();
  posthog.setPersonProperties({ user_connected: userConnected });
  posthog.capture("$pageview", {
    user_connected: userConnected,
    $set: { user_connected: userConnected }
  });
  return userConnected;
};

export const trackLinkClicks = (userConnected: boolean) => {
  document.querySelectorAll("a").forEach((button) => {
    button.addEventListener("click", () => {
      posthog.capture("click-button", {
        user_connected: userConnected,
        "button-id": button.id || "no-id",
        button_id: button.id || "no-id",
        "data-framer-name": button.getAttribute("name") || "no-framer-name",
        destination_url: button.href || "no-url",
        $set: { user_connected: userConnected }
      });
      posthog.capture("click_button", {
        user_connected: userConnected,
        button_id: button.id || "no-id",
        "data-framer-name": button.getAttribute("name") || "no-framer-name",
        destination_url: button.href || "no-url",
        $set: { user_connected: userConnected }
      });
    });
  });
};
